document.documentElement.classList.add('sn-ready');

const qs = (selector, scope = document) => scope.querySelector(selector);
const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

function initMobileMenu() {
  const toggle = qs('.mobile-menu-toggle');
  const nav = qs('#SiteNav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    document.documentElement.classList.toggle('sn-menu-open', !isOpen);
  });

  qsa('a', nav).forEach((link) => {
    link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('sn-menu-open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('sn-menu-open');
  });
}

function initPersonalisationPreview() {
  const form = qs('.product-form');
  const preview = qs('[data-preview-text]');
  if (!form || !preview) return;

  const fields = {
    text: qs('#EmbroideryText', form),
    placement: qs('#EmbroideryPlacement', form),
    colour: qs('#LogoColour', form),
    academy: qs('#AcademyName', form),
    notes: qs('#CustomNotes', form),
  };

  const update = () => {
    const lines = [];
    if (fields.text?.value.trim()) lines.push(`Text: ${fields.text.value.trim()}`);
    if (fields.placement?.value) lines.push(`Placement: ${fields.placement.value}`);
    if (fields.colour?.value) lines.push(`Thread/logo colour: ${fields.colour.value}`);
    if (fields.academy?.value.trim()) lines.push(`Academy/team: ${fields.academy.value.trim()}`);
    if (fields.notes?.value.trim()) lines.push(`Notes: ${fields.notes.value.trim()}`);

    preview.textContent = lines.length ? lines.join(' · ') : 'No personalisation added yet.';
    form.classList.toggle('has-personalisation', lines.length > 0);
  };

  Object.values(fields).forEach((field) => {
    if (!field) return;
    field.addEventListener('input', update);
    field.addEventListener('change', update);
  });

  update();
}

function initFormStates() {
  qsa('form').forEach((form) => {
    form.addEventListener('submit', () => {
      form.classList.add('is-submitting');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initPersonalisationPreview();
  initFormStates();
});
